import { type AnyAction, combineReducers } from 'redux';

import {
    storeDocumentId,
    storeDocumentLanguageCode,
    storeDocumentName,
    storeDocumentUrl,
} from 'js/src/data/document/document-actions';

export function document_id(state: number | null = null, action: AnyAction) {
    if (storeDocumentId.match(action)) {
        return action.payload.documentId;
    }
    return state;
}

export function document_url(state = '', action: AnyAction) {
    if (storeDocumentUrl.match(action)) {
        return action.payload.documentUrl;
    }
    return state;
}

export function document_name(state = '', action: AnyAction) {
    if (storeDocumentName.match(action)) {
        return action.payload.documentName;
    }
    return state;
}

export function document_language_code(state = '', action: AnyAction) {
    if (storeDocumentLanguageCode.match(action)) {
        return action.payload.documentLanguageCode;
    }
    return state;
}

export const document = combineReducers({
    document_id,
    document_name,
    document_url,
    document_language_code,
});

export type DocumentState = ReturnType<typeof document>;
